import digitalData from 'digital-data';
import { BUTTON_SUBMISSION, OVERLAY, INSTANT_CHECKOUT } from '../constants.js';
export const instantCheckoutPageOverlay = () => {
  const trackEvent = event => {
    digitalData.event = digitalData.event || [];
    digitalData.event.push(event);
  };
  const instantChekoutPageEvents = {
    modifyICAddressPaymentOverlay: _ref => {
      let {
        output
      } = _ref;
      const {
        value
      } = output;
      const DDOEvent = {
        category: {
          primaryCategory: OVERLAY
        },
        eventInfo: {
          eventName: value
        }
      };
      trackEvent(DDOEvent);
    },
    instantChekoutPageButtonSubmission: _ref2 => {
      let {
        output
      } = _ref2;
      const {
        overlayType,
        action
      } = output;
      const DDOEvent = {
        category: {
          primaryCategory: BUTTON_SUBMISSION
        },
        eventInfo: {
          eventName: 'my account settings'
        },
        myAccount: {
          settings: `${INSTANT_CHECKOUT}: ${overlayType} overlay: ${action}`
        }
      };
      trackEvent(DDOEvent);
    },
    addressPaymentUpdateSuccess: _ref3 => {
      let {
        output
      } = _ref3;
      const {
        action,
        item
      } = output;
      const DDOEvent = {
        category: {
          primaryCategory: BUTTON_SUBMISSION
        },
        eventInfo: {
          eventName: 'my account settings'
        },
        myAccount: {
          settings: `${INSTANT_CHECKOUT}: ${action} ${item}: ${item} updated: success`
        }
      };
      trackEvent(DDOEvent);
    },
    continueShoppingLinkClick: _ref4 => {
      let {
        output
      } = _ref4;
      const DDOEvent = {
        category: {
          primaryCategory: BUTTON_SUBMISSION
        },
        eventInfo: {
          eventName: 'my account settings'
        },
        myAccount: {
          settings: `${INSTANT_CHECKOUT}: ${output} updated: success: continue shopping`
        }
      };
      trackEvent(DDOEvent);
    },
    pagination: _ref5 => {
      let {
        output
      } = _ref5;
      const {
        overlayName,
        action,
        pageNumber
      } = output;
      const DDOEvent = {
        category: {
          primaryCategory: BUTTON_SUBMISSION
        },
        eventInfo: {
          eventName: 'my account settings'
        },
        myAccount: {
          settings: `${INSTANT_CHECKOUT}: ${overlayName}: ${action}: ${pageNumber}`
        }
      };
      trackEvent(DDOEvent);
    },
    postPageErrors: _ref6 => {
      let {
        output
      } = _ref6;
      const {
        pageSection,
        message,
        code,
        type,
        displayType
      } = output;
      const pageErrors = [];
      const errorDetails = {
        eventName: 'post page error',
        type,
        displayType,
        pageSection,
        message,
        code
      };
      pageErrors.push(errorDetails);
      const DDOEvent = {
        category: {
          primaryCategory: 'error'
        },
        eventInfo: {
          eventName: 'post page error',
          error: pageErrors
        }
      };
      trackEvent(DDOEvent);
    }
  };
  window.LIFE_CYCLE_EVENT_BUS.on('instant-checkout-page-modify-overlay', instantChekoutPageEvents.modifyICAddressPaymentOverlay);
  window.LIFE_CYCLE_EVENT_BUS.on('instant-checkout-page-button', instantChekoutPageEvents.instantChekoutPageButtonSubmission);
  window.LIFE_CYCLE_EVENT_BUS.on('instant-checkout-page-update-success', instantChekoutPageEvents.addressPaymentUpdateSuccess);
  window.LIFE_CYCLE_EVENT_BUS.on('instant-checkout-post-page-error', instantChekoutPageEvents.postPageErrors);
  window.LIFE_CYCLE_EVENT_BUS.on('instant-checkout-continue-shopping', instantChekoutPageEvents.continueShoppingLinkClick);
  window.LIFE_CYCLE_EVENT_BUS.on('instant-checkout-pagination', instantChekoutPageEvents.pagination);
};
//# sourceMappingURL=instant-checkout-page.listener.analytics.js.map